let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jNW0I")).then(() => parcelRequire('bwZ8R'));